import React, { lazy, Suspense } from "react";
import EstateArea from "@/pages/sites/EstateArea";
import { isEstate, isPreviewing } from "@/lib/sitePreview";
import { useBrand } from "@/lib/brand";
import { SITE_FALLBACK } from "@/lib/classicChunk";

// The classic design, fetched only if this agency is on it. See
// pages/classic/AreaLandingPageClassic.jsx for why it is not imported directly.
const AreaLandingPageClassic = lazy(() => import("@/pages/classic/AreaLandingPageClassic"));

function ClassicArea(props) {
  return <Suspense fallback={SITE_FALLBACK}><AreaLandingPageClassic {...props} /></Suspense>;
}

/**
 * Foundation Reach — one SEO landing page per area an agency serves.
 * Renders at /t/:slug/area/:area (the "area" slug matches what
 * GET /crm/reach/landing-pages hands back to the agent as `p.slug`).
 */

export default function AreaLandingPage(props) {
  const brand = useBrand();
  // The new design, behind the same flag every other page uses. See
  // lib/sitePreview.js: nobody sees it who has not typed ?theme=estate.
  const estate = isEstate(brand);
  const previewing = isPreviewing(brand);
  if (estate && !props.bare) return <EstateArea preview={previewing} />;
  return <ClassicArea {...props} />;
}
